import { validate as uuidValidate, v4 as uuidv4 } from 'uuid';

/**
 * Test if the input string is the valid UUID
 * @param id string
 * @returns return boolean
 */
export function isValidUUID(id: string) {
  return uuidValidate(id);
}

/**
 * @description This function is used to generate a new UUID
 * @returns string
 */
export function generateUUID() {
  return uuidv4();
}
